export const domain = process.env.REACT_APP_DOMAIN as string
export const gaTrackingID = process.env.REACT_APP_GA_TRACKING_ID as string
